import { render, staticRenderFns } from "./invoice-base-list.vue?vue&type=template&id=559f604c&"
import script from "./invoice-base-list.vue?vue&type=script&lang=ts&"
export * from "./invoice-base-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports